<template>
    <div class="container"  v-title="'赛事详情'">
        <Navigation-bar id="navigation_bar" type="dark" :class="{'show':tabFixed}">
            <template slot="title">
                <div class="macth_title" v-show="tabFixed">
                    <div class="match_logo" v-if="subLeagueData.LogoUrl" >
                        <img :src="subLeagueData.LogoUrl">
                    </div>
                    <p class="name">{{Description.Name}}</p>
                </div>
            </template>
            <YD-image src="icon/icon_nav_分享_白色" class="share" 
                v-share="{
                    Type: 5,
                    Title: ['报名即将开始', '火热报名中', '即将开赛', '激烈进行中', ''][subLeagueData.Status - 1],
                    Text: Description.Name,
                    Link: 'https://m.dazhongyundong.com/app_download/',
                    LinkText: '立即下载APP：',
                    ImgLink: Description.LogoUrl
                }" 
                v-if="isShare && $appVersion >= '22093000'"></YD-image>
        </Navigation-bar>
        <div class="container_content">
            <div id="Match_detail" ref="Match_detail" v-show="pageShow">
                <Scroll
                    ref="scroll"
                    @scrollChange="scrollChange"
                    @scrollEnd="scrollEnd"
                >
                    <div class="MD_content">
                        <div class="match_img" :style="{'background-image': `url(${Description.CoverThumbUrl})`}">
                            <img :src="Description.LogoUrl">
                            <div class="give_notice" v-if="subLeagueData.AbnormalStatus > 0 && subLeagueData.BulletinUrl"  @click="openNotice(subLeagueData.BulletinUrl)">
                                <YD-image src="icon/icon_通知"></YD-image>
                                <div class="give_notice_conetnt" ref="give_notice_conetnt">
                                    <p>{{['','赛事取消','赛事延期','赛事中断'][subLeagueData.AbnormalStatus]}}：{{subLeagueData.BulletinTitle}}</p>
                                </div>
                                <YD-image src="icon/icon_arrow_1"></YD-image>
                            </div>
                        </div>
                        <div class="tab" ref="tab" :class="{'shadow': [1, 2, 4].includes(tabId) && tabFixed}">
                            <div class="tab_fixed">
                                <ul>
                                    <li v-for="(item,index) in tabs" :key="index"
                                        :class="{'active':tabId == item.Id}"
                                        @click="selectTab(item.Id)"><span>{{item.Name}}</span></li>
                                </ul>
                            </div>
                        </div>
                        <template v-if="isSynthesis && eventsList.length > 0">
                            <div class="events" ref="events" :class="{ 'shadow': tabId == 3 && !eventsActive.IsHaveScore && tabFixed}" v-if="[3,5].includes(tabId)">
                                <ul class="list">
                                    <li class="item" :class="{'active': item.EventsName == eventsActive.EventsName}" v-for="(item,index) in eventsList" :key="index" @click="selectEvents(item)">{{item.EventsName}}</li>
                                </ul>
                                <div class="icon">
                                    <YD-image src="icon/match_events_down" @click.native="openSelectEvents"></YD-image>
                                </div>
                            </div>
                        </template>
                        <div class="tab_content" :class="{'is-enroll': isEnroll || isSpecial}" :style="{'min-height': minHeight}">
                            <ul>
                                <li v-for="(item,index) in tabs" :key="index"
                                    :class="{'active': tabId == item.Id}"
                                >
                                    <template v-if="item.Id == 1">
                                        <Detail
                                            ref="tabCentent1"
                                            :subLeagueData="subLeagueData" 
                                            v-if="tabContents.includes(item.Id)"
                                            @lookImage="lookImage"
                                        ></Detail>
                                    </template>
                                    <template v-else-if="item.Id == 2">
                                        <EnrollDetail
                                            ref="tabCentent2"
                                            :subLeagueId="subLeagueId"
                                            v-if="tabContents.includes(item.Id)"
                                        ></EnrollDetail>
                                    </template>
                                    <template v-else-if="item.Id == 3">
                                        <GemaResult
                                            ref="tabCentent3"
                                            :subLeagueId="subLeagueId" 
                                            :channelUrl="item.channelUrl"
                                            :isFixed="tabFixed"
							                :hasScored="item.HasScored" 
                                            :isSynthesis="isSynthesis" 
                                            :events="eventsActive"
                                            v-if="tabContents.includes(item.Id)"
                                        ></GemaResult>
                                    </template>
                                    <template v-else-if="item.Id == 4">
                                        <Communique
                                            ref="tabCentent4"
                                            :channelId="item.channelId"
                                            :channelUrl="item.channelUrl"
                                            v-if="tabContents.includes(item.Id)"
                                        ></Communique>
                                    </template>
                                    <template v-else-if="item.Id == 5">
                                        <Moments
                                            ref="tabCentent5"
                                            :channelUrl="item.channelUrl"
                                            :isFixed="tabFixed" 
                                            :isCurrentShow="item.Id == tabId"
                                            :isSynthesis="isSynthesis" 
                                            :events="eventsActive"
                                            v-if="tabContents.includes(item.Id)"
                                            @lookImage="lookImage"
                                        ></Moments>
                                    </template>
                                </li>
                            </ul>
                        </div>
                    </div>
                </Scroll>
            </div>
        </div>
        <div id="Enroll_operation" v-if="isSpecial">
            <button @click="go2Zhish(subLeagueData.BulletinUrl)">{{subLeagueData.BulletinTitle}}</button>
        </div>
        <div id="Enroll_operation" v-else-if="!Description.IsOnline && isEnroll">
            <button @click="openEnrollModel()">我要报名</button>
        </div>
        <template v-else-if="Description.IsOnline && !!subLeagueData.LeagueSite">
            <div class="enter_operation" v-if="[2,3,4].includes(subLeagueData.Status) && !onlineEnrollStatus">
                <button @click="onlineEnroll()">我要报名</button>
            </div>
            <div class="enter_operation" v-else-if="subLeagueData.Status == 4 && onlineEnrollStatus">
                <button @click="enterMatch()">
                    <span>立即参赛</span>
                    <div class="bubble">您已报名，点击按钮参赛</div>
                </button>
            </div>
            <div class="enter_hint" v-else-if="[2,3].includes(subLeagueData.Status) && onlineEnrollStatus">您已报名成功，请于{{beginDateText}}参加比赛</div>
        </template>
        <ImagePreview v-model="image.show" :images="image.list" :start-position="image.index" @change="image.index = $event" lazyLoad></ImagePreview>
        <YD-image src="icon/icon_保存" class="save_image" v-show="image.show" @click.native="saveImage"></YD-image>
        <Popup ref="enrollPopup">
            <div class="enroll">
                <YD-image src="icon/icon_dialog_close" @click.native="closeEnrollPopup"></YD-image>
                <div class="enroll_content">
                    <div class="files">
                        <p v-for="(item,index) in handleInstrumentList" :key="index">《<span @click="openFile(item.InstrumentUrl, item.InstrumentName)">{{item.name}}</span>》</p>
                    </div>
                    <p class="AdmissionInformation" v-if="isShowAdmissionInformation">其他事项请阅读 <span @click="go2EnrollRule">报名须知</span></p>
                    <div class="consent" v-if="isShowAdmissionInformation">
                        <button :class="{'active':isAgree}" @click.stop="agreeClick"></button>
                        <span>我已阅读并同意</span>
                    </div>
                </div>
                <div class="entrance one" v-if="allowType < 3">
                    <button @click="enrollClick(allowType)">进入报名</button>
                </div>
                <div class="entrance tow" v-else>
                    <button @click="enrollClick(1)">代表队报名</button>
                    <button @click="enrollClick(2)">个人报名</button>
                </div>
            </div>
        </Popup>  
        <Popup ref="eventsPopup" type="top">
			<div class="events_all">
				<div class="content">
					<div class="title">
						<span>全部项目</span>
                        <YD-image src="icon/match_events_up" @click.native="closeSelectEvents"></YD-image>
					</div>
					<ul class="list">
						<li class="item" :class="{'active': item.EventsName == eventsActive.EventsName}" v-for="(item,index) in eventsList" :key="index" @click="selectEvents(item, true)">{{item.EventsName}}</li>
					</ul>
				</div>
			</div>
        </Popup>     
    </div>
</template>
<script>
import tools from '@/common/tools.js';
import appInteraction from '@/common/appInteraction.js';
import { ImagePreview } from 'vant';
import 'vant/lib/image-preview/style';
import hammerjs from 'hammerjs';
import Popup from '../../components/Popup.vue';
import Detail from './components/Detail.vue';//竞赛规程
import GemaResult from './components/GemaResult.vue';//赛程赛果
import EnrollDetail from './components/EnrollDetail.vue';//报名详情
import Communique from './components/Communique.vue';//官方公告
import Moments from './components/Moments.vue';//精彩瞬间
import communicate from '@/common/communicate';
export default {
    name:"MatchDetail",
    components:{
        Popup,
        Detail,
        GemaResult,
        EnrollDetail,
        Communique,
        Moments,
        ImagePreview: ImagePreview.Component
    },
    data(){
        return{
            subLeagueId: parseInt(this.$route.params.id),
            pageShow: false,
            isShare: false,
            subLeagueData: {},
            tabFixed: false,
            tabs:[],
            tabId: 0,//tab
            tabContents: [],

            allowType: false,
            confirmAdmissionInformation: false,
            isAgree: false,
            instrumentList: [],
            isShowAdmissionInformation: false,

            image:{
                list: [],
                index: 0,
                show: false
            },
            onlineEnrollStatus: false,
            eventsList: [],
            eventsActive: null,
            eventsListScroll: 0
        }
    },
    created(){
        sessionStorage.removeItem('team');
        sessionStorage.removeItem('teamMembers');
        this.getDetail();
        communicate.admissionInformation.$on(()=>{
            this.confirmAdmissionInformation = true;
            this.isAgree = true;
        })
    },
    mounted() {
        var _this = this;
        var mc = new hammerjs.Manager(this.$el,{
            threshold: 100
        });
        var swipe = new hammerjs.Swipe();
        mc.add(swipe);
        mc.on('swiperight', function(e) {
            if(!_this.image.show){
                _this.$navigation.back();
            }
        });
    },
    destroyed() {
        communicate.admissionInformation.$off();
    },
    computed:{
        fixedTop(){
            return tools.remToPx(422 - 88);
        },
        minHeight(){
            return `calc(100vh - ${tools.remToPx(88 + 80)}px)`;
        },
        Description(){ return this.subLeagueData.Description || {}},
        isEnroll(){
            return this.subLeagueData.Status == 2;
        },
        beginDateText(){
            return tools.dateFormat(this.subLeagueData.GameTime.BeginTime, 'yyyy年M月d日');
        },
        //综合运动会
        isSynthesis(){
            return this.Description.EventsId == 2;
        },
        isSpecial(){
            return this.isSynthesis && this.subLeagueData.Status >= 3 && this.subLeagueData.BulletinTitle && this.subLeagueData.BulletinUrl;
        },
        handleInstrumentList(){
            if(!this.instrumentList) return [];
            return this.instrumentList.map(item=>{
                let name = item.InstrumentName;
                return {
                    ...item,
                    name: name.substr(0, name.lastIndexOf('.')) || name
                }
            })
        },
    },
    watch:{
        pageShow(){
            this.$nextTick(function(){
                this.scrollH = this.$refs['Match_detail'].offsetHeight;
            })
        }
    },
    methods:{
        setScrollTop(){
			if(this.tabFixed){
                this.$refs.scroll.scrollTo({
                    scrollTop: this.fixedTop + 1,
                    behavior: 'instant'
                })
            }
        },
        scrollChange(scrollTop){
            if(scrollTop >= this.fixedTop){
                this.tabFixed = true;
            }else{
                this.tabFixed = false;
            }
        },
        scrollEnd(){
            let ref = this.$refs[`tabCentent${this.tabId}`][0];
            if(ref && ref.scrollEnd) ref.scrollEnd();
        },
        getDetail(){
            this.$api.GetSubLeagueDetail({
                SubLeagueId: this.subLeagueId
            }).then(data=>{
                if(data.Code == 0){
                    this.pageShow = true;
                    this.isShare = true;
                    this.subLeagueData = data.SubLeague;
                    let tabs = [{
                        Id: 1,
                        Name: '竞赛规程'
                    }];
                    if(data.SubLeague.SscmsCntsCountInfo && data.SubLeague.SscmsCntsCountInfo.length > 0){
                        let channelList = data.SubLeague.SscmsCntsCountInfo;
                        let communiqueObj = null,
                            gemaResultObj = null,
                            momentsObj = null;

                        for(let i=0, len = channelList.length;i<len;i++){
                            let {
                                ChannelType,
                                ChannelName: Name,
                                ChannelId: channelId,
                                Url: channelUrl
                            } = channelList[i];
                            switch (ChannelType){
                                case 'notice':
                                    communiqueObj = { Name, channelId, channelUrl };
                                    break;
                                case 'progress':
                                    gemaResultObj = { Name, channelId, channelUrl };
                                    break;
                                case 'album':
                                    momentsObj = { Name, channelId, channelUrl };
                                    break;
                            }
                        }
                        if(communiqueObj){
                            tabs.push({
                                Id: 4,
                                ...communiqueObj
                            })
                        }
                        if(data.SubLeague.IsShowEnrollDetail){
                            tabs.push({
                                Id: 2,
                                Name: '报名详情'
                            })
                        }
                        if(gemaResultObj || data.SubLeague.HasScoredLeagueGroups){
                            let obj = {
                                Id: 3,
                                Name: gemaResultObj ? gemaResultObj.Name : '比赛成绩'
                            }
                            obj.HasScored = !!data.SubLeague.HasScoredLeagueGroups;
                            tabs.push({
                                ...obj,
                                ...(gemaResultObj || {})
                            })
                        }
                        if(momentsObj){
                            tabs.push({
                                Id: 5,
                                ...momentsObj
                            })
                        }
                    }else{
                        if(data.SubLeague.IsShowEnrollDetail){
                            tabs.push({
                                Id: 2,
                                Name: '报名详情'
                            })
                        }
                        if(data.SubLeague.HasScoredLeagueGroups){
                            tabs.push({
                                Id: 3,
                                Name: '比赛成绩',
                                HasScored: true
                            })
                        }
                    }
                    this.tabs = tabs;
                    this.selectTab(tabs[0].Id);
                    if(data.SubLeague.AbnormalStatus > 0 && data.SubLeague.BulletinUrl){
                        this.$nextTick(function(){
                            this.giveNoticeScroll();
                        })
                    }
                    if(data.SubLeague.Description.IsOnline && !!data.SubLeague.LeagueSite){
                        appInteraction.getUserState().then(loginType=>{
                            if(loginType != 0){
                                this.getOnlineEnrollStatus();
                            }
                        })
                    }
                    if(data.SubLeague.Description.EventsId == 2){
                        this.getEvents();
                    }
                }
            })
        },
        //新闻
        giveNoticeScroll(){
            var contentBox = this.$refs['give_notice_conetnt'];
            if(contentBox.scrollWidth > contentBox.offsetWidth + 3){
                contentBox.style.width = contentBox.offsetWidth + 'px';
                let max =  contentBox.scrollWidth - contentBox.offsetWidth;
                this.move(contentBox.childNodes[0], max);
            }
        },
        move(el,max){
            var n = 0;
            this.timer = null;
            this.outTimer = null;
            this.timer = setInterval(()=>{
                if(n >= max){
                    n = 0;
                    el.style.left = -n + 'px';
                    clearInterval(this.timer);
                    clearTimeout(this.outTimer);
                    this.outTimer = setTimeout(()=>{
                        this.move(el,max);
                    },1000)
                    return;
                }
                n += 0.4;
                el.style.left = -n + 'px';
            },20)
        },
        selectTab(tabId){
            if(!this.tabContents.includes(tabId)){
                this.tabContents.push(tabId);
            }
            if(this.tabId != tabId){
                this.tabId = tabId;
                this.setScrollTop();
            }
        },
        //获取项目
        getEvents(){
            this.$api.json(`https://file.dazhongyundong.com/zhish/${this.subLeagueId}/zhishaEvents.json`).then(list => {
                if(list && list.length > 0){
                    this.eventsList = list;
                    this.eventsActive = list[0];
                }
            });
        },
        //选择项目
        openSelectEvents(){
            this.$refs.eventsPopup.open()
        },
        closeSelectEvents(){
            this.$refs.eventsPopup.close();
        },
        selectEvents(item, isScroll){
            if(this.eventsActive.EventsName != item.EventsName){
                if(isScroll){
                    this.computedSelect(item);
                }else{
                    this.eventsActive = {...item};
					this.closeSelectEvents();
                }
                this.setScrollTop();
            }else{
                this.closeSelectEvents();
            }
        },
        computedSelect(obj){
            let width = tools.remToPx(750 - 92);
            let index = this.eventsList.findIndex(item=>item.EventsName == obj.EventsName);
            let nodes = this.$refs.events.querySelectorAll('.list .item');
            let allWidth = tools.remToPx(40);
            let left = 0;
            let margin = tools.remToPx(16);
            nodes.forEach((item,i)=>{
                allWidth += item.offsetWidth + (i < nodes.length-1 ? margin : 0);
                if(i < index){
                    left += item.offsetWidth + margin;
                }
            })
            if(allWidth > width){
                if(left > allWidth - width){
                    left = allWidth - width;
                }
                //this.eventsListScroll = left;
                let listNode = this.$refs.events.querySelector('.list');
                listNode.scrollLeft = left;
            }
            this.eventsActive = {...obj};
            this.closeSelectEvents();
        },
        openNotice(bulletinUrl){
            if(bulletinUrl){
                appInteraction.webviewOpenUrl(bulletinUrl);
            }
        },
        openFile(file_url, name){
            this.$navigation.go('/Rules/OnlinePreview?type=pdf&file_url='+encodeURIComponent(file_url)+'&name='+name+'&download=1');
        },
        //跳转职沙会
        go2Zhish(url){
            appInteraction.webviewOpenUrl(url);
        },
        //报名
        openEnrollPopup(){
            Promise.all([
                this.$api.GetLeagueEnrollInstrument({
                    SubLeagueId: this.subLeagueId
                }),
                this.$api.GetLeagueEnrollWay({
                    LeagueId: this.subLeagueId
                }),
                this.$api.GetLeagueEnrollNotice({
				    LeagueId: this.subLeagueId
				})
            ]).then(results=>{
                if(results.every(data=>data.Code === 0)){
                    if(results[0]){
                        let data = results[0];
                        this.instrumentList = data.InstrumentList;
                    }
                    if(results[1]){
                        let data = results[1];
                        if(data.IsAllowDptEnroll && data.IsAllowIndividualEnroll){
                            this.allowType = 3;
                        }else if(data.IsAllowDptEnroll){
                            this.allowType = 1;
                        }else if(data.IsAllowIndividualEnroll){
                            this.allowType = 2;
                        }
                    }
                    if(results[2]){
                        let data = results[2];
					    this.isShowAdmissionInformation = data.Notice && data.Notice.EnrollNotice;
                    }
                    this.$refs.enrollPopup.open();
                }
            })
        },
        closeEnrollPopup(){
            this.$refs.enrollPopup.close();
        },
        openEnrollModel(){
            if(this.Description.EventsId == 2){
                this.$Prompt({
                    title: '赛事报名',
                    message: '点击“确定”将跳转到“亿动体育”小程序进行报名。',
                    showCancel: true,
                }).then(confirm=>{
                    if(confirm){
                        appInteraction.jumpWxMiniApp(`/pages/Match/MatchDetail/MatchDetail?SubLeagueId=${this.subLeagueId}`);
                    }
                })
                return;
            }
            appInteraction.getUserState().then(loginType=>{
                if(loginType == 0){
                    appInteraction.go2Login(1).then(()=>{
                        this.openEnrollPopup();
                    })
                }else{
                    this.openEnrollPopup();
                }
            })
        },
        agreeClick() {
            if(!this.isAgree && !this.confirmAdmissionInformation){
                this.$api.GetUserAgreeLeagueEnrollNoticeStatus({
                    LeagueId: this.subLeagueId
                }).then(data=>{
                    if(data.Code == 0){
                        if(data.IsAgree){
                            this.isAgree = true;
                            this.confirmAdmissionInformation = true;
                        }else{
                            this.go2EnrollRule();
                        }
                    }
                })
                return;
            }
            this.isAgree = !this.isAgree;
        },
        go2EnrollRule(){
            this.$navigation.go('/Enroll/AdmissionInformation?subLeagueId=' + this.subLeagueId);
        },
        enrollClick(type){
            if(!this.isShowAdmissionInformation){
                this.go2Entrance(type);
                return;
            }
            if (!this.confirmAdmissionInformation || !this.isAgree) {
                this.$Toast("请先阅读报名须知并勾选同意");
            } else {
                this.go2Entrance(type);
            }
        },
        go2Entrance(type){
            this.closeEnrollPopup();
            this.isAgree = false;
            if(type == 1){
                this.$navigation.go('/Enroll/TeamPersonnel?subLeagueId=' + this.subLeagueId);
            }else{
                this.$navigation.go('/Enroll/OneselfEnroll/Personnel?subLeagueId=' + this.subLeagueId);
            }
        },
        onlineEnroll(){
            appInteraction.getUserState().then(loginType=>{
                if(loginType == 0){
                    appInteraction.go2Login(1).then(()=>{
                        this.getOnlineEnrollStatus();
                    })
                }else{
                    this.$api.UserLeagueOnlineEnroll({
                        LeagueId: this.subLeagueId
                    }).then(data=>{
                        if(data.Code == 0){
                            this.$Prompt({
                                title: "报名成功",
                                message: [2,3].includes(this.subLeagueData.Status) ? `报名成功，请于${this.beginDateText}参加比赛` : '报名成功，请点击“立即参赛”按钮。',
                                confirmText: "知道了"
                            }).then(()=>{
                                this.onlineEnrollStatus = true;
                            })
                        }
                    })
                }
            })
        },
        async enterMatch(){
            if(!tools.isVersion('23071000')){
                this.$Prompt({
                    title: '请更新版本',
                    message: "必须更新app版本，才能参与比赛。",
                    confirmText: "知道了"
                })
            }else{
                await new Promise((resolve)=>{
                    appInteraction.getUserState().then(loginType=>{
                        if(loginType == 0){
                            appInteraction.go2Login(1).then(()=>{
                                resolve();
                            })
                        }else{
                            resolve();
                        }
                    })
                })
                this.$api.GetJumpUserInfo({
                    "AppId": "mi_gu",
                    "PartnerRequestPath": this.subLeagueData.LeagueSite
                }).then(data=>{
                    if(data.Code == 0){
                        appInteraction.webviewOpenUrl(data.PartnerRequestPath);
                    }
                })
            }
        },
        lookImage(imageObj){
            this.$set(this, 'image', imageObj);
        },
        saveImage(){
            let {
                list,
                index
            } = this.image;
            appInteraction.saveImage(list[index]);
        },
        getOnlineEnrollStatus(){
            this.$api.GetUserLeagueOnlineEnrollStatus({
                LeagueId: this.subLeagueId
            }).then(data=>{
                if(data.Code == 0){
                    this.onlineEnrollStatus = data.IsEnrolled;
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
@import './assets/scss/MatchDetail.scss';
</style>